import { SalesLeadData } from "../../../modules/Utilities/ConfigureAgreement/SalesLead/types/SalesLeadInterface";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getSalesLead = async () => {
  const data = await axios.get(`${api_base_url}/SalesLead`);

  //const { data } = await axios.get("https://localhost:44399/api/TargetSyStem");
  return data;
};

export const updateSalesLead = async (updatedSalesLead: SalesLeadData) => {
  const data = await axios.put(
    `${api_base_url}/SalesLead/SalesLeadBy/${updatedSalesLead.id}`,
    updatedSalesLead
  );
  return data;
};

export const addSalesLead = async (newSalesLead: SalesLeadData) => {
  const { data } = await axios.post(
    `${api_base_url}/SalesLead/AddSalesLead`,
    newSalesLead
  );
  return data;
};

export const deleteSalesLead = async (leadIds: number[]) => {
  await axios.delete(`${api_base_url}/SalesLead/DeleteLead`, {
    data: leadIds,
  });
};
